module.exports = __webpack_public_path__ + "mobile/img/voi_icon.35d7a25d.svg";